/* eslint-disable @typescript-eslint/member-ordering */
import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { MAT_LEGACY_SNACK_BAR_DATA, MatLegacySnackBarRef } from '@angular/material/legacy-snack-bar';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/legacy-snack-bar";
import * as i2 from "@angular/common";
function SnackbarComponent_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 3);
    i0.ɵɵlistener("click", function SnackbarComponent_a_5_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.action()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.actionLabel);
} }
/**
 * Application default snackbar which shows a message and action
 *
 * @export
 * @class SnackbarComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 * @implements {AfterViewInit}
 * @implements {SnackBarComponentType}
 */
export class SnackbarComponent {
    /**
     * Creates an instance of SnackbarComponent.
     *
     * @param {MatLegacySnackBarRef<SnackBarComponentType>} snackBarRef
     * @param {*} data
     * @memberof SnackbarComponent
     */
    constructor(snackBarRef, data) {
        this.snackBarRef = snackBarRef;
        this.data = data;
        this.type = data.type;
        this.message = data.props['message'];
        this.actionLabel = data.props['button'] ? data.props['button'].label : undefined;
        this.hasAction = !!data.props['button'];
        this.addSubscribers();
    }
    /**
     * Adds the subscribers for afterDismisses, afterOpened and onAction
     *
     * @private
     * @memberof SnackbarComponent
     */
    addSubscribers() {
        // Snackbar on dismissed forcefully or timeout
        this.subDismiss = this.snackBarRef.afterDismissed().subscribe(() => {
            if (this.subDismiss) {
                this.subDismiss.unsubscribe();
            }
            const afterDismiss = this.data.props['afterDismissCallback'];
            if (afterDismiss) {
                afterDismiss();
            }
        });
        this.subOpened = this.snackBarRef.afterOpened().subscribe(() => {
            const afterOpen = this.data.props['afterOpenCallback'];
            if (afterOpen) {
                afterOpen();
            }
        });
        this.subAction = this.snackBarRef.onAction().subscribe(() => {
            const action = this.data.props['button'].action;
            if (action) {
                action();
            }
        });
    }
    /**
     * Invoked from the markup when the action button is clicked
     *
     * @memberof SnackbarComponent
     */
    action() {
        this.snackBarRef.dismissWithAction();
    }
    /**
     * Invoked to close the snackbar
     *
     * @memberof SnackbarComponent
     */
    close() {
        this.snackBarRef.dismiss();
    }
    /**
     * Unsubscribes the subscribers on component destroy
     *
     * @memberof SnackbarComponent
     */
    ngOnDestroy() {
        this.subOpened.unsubscribe();
        this.subAction.unsubscribe();
    }
    static { this.ɵfac = function SnackbarComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SnackbarComponent)(i0.ɵɵdirectiveInject(i1.MatLegacySnackBarRef), i0.ɵɵdirectiveInject(MAT_LEGACY_SNACK_BAR_DATA)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SnackbarComponent, selectors: [["app-snackbar"]], standalone: false, decls: 7, vars: 2, consts: [[1, "snack-bar-container", 3, "click"], [1, "items"], ["class", "mat-simple-snackbar-action", 3, "click", 4, "ngIf"], [1, "mat-simple-snackbar-action", 3, "click"]], template: function SnackbarComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function SnackbarComponent_Template_div_click_0_listener() { return ctx.close(); });
            i0.ɵɵtext(1, "\n  ");
            i0.ɵɵelementStart(2, "div", 1);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(4, "\n  ");
            i0.ɵɵtemplate(5, SnackbarComponent_a_5_Template, 2, 1, "a", 2);
            i0.ɵɵtext(6, "\n");
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.message, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.hasAction);
        } }, dependencies: [i2.NgIf], styles: ["/* ../../libs/web/angular/shared/ui/notifications/src/lib/snackbar/snackbar-default.raw.scss */\n.mat-snack-bar-container {\n  height: fit-content;\n  min-width: 240px;\n}\n.snack-bar-container {\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n  font-family:\n    Roboto,\n    \"Helvetica Neue\",\n    sans-serif;\n  white-space: pre-line;\n}\n.items {\n  flex: 90%;\n  word-wrap: break-word;\n  overflow: hidden;\n}\n.mat-simple-snackbar-action {\n  color: white;\n  margin-left: 30px;\n  flex: 10%;\n  cursor: pointer;\n}\nsnack-bar-container.success {\n  background-color: #25B67F;\n}\nsnack-bar-container.error {\n  background-color: #F44C47;\n}\nsnack-bar-container.info {\n  background-color: #323232;\n}\nsnack-bar-container.warning {\n  background-color: #FB7F28;\n}\n"], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SnackbarComponent, { className: "SnackbarComponent", filePath: "libs/web/angular/shared/ui/notifications/src/lib/snackbar/snackbar.component.ts", lineNumber: 25 }); })();
//# sourceMappingURL=snackbar.component.js.map